export type Predicate<Value = unknown> = (value: Value) => boolean

export function getStorageItem(key: string): string | undefined {
  try {
    return localStorage.getItem(key) ?? undefined
  } catch {
    return undefined
  }
}

export function saveJson<V>(key: string, value: V | undefined): void {
  try {
    if (value === undefined) localStorage.removeItem(key)
    else localStorage.setItem(key, JSON.stringify(value))
  } catch (e) {
    console.error('save failed', key, e)
  }
}

export function loadJson<V>(key: string): V | undefined {
  try {
    const text = localStorage.getItem(key)
    return text ? JSON.parse(text) : undefined
  } catch (e) {
    console.error('load failed', key, e)
    return undefined
  }
}

export function findJson<V>(predicate: Predicate<any>): V | undefined {
  for (let index = 0; index < localStorage.length; ++index) {
    const key = localStorage.key(index)
    if (!key) continue
    try {
      const text = localStorage.getItem(key)
      const json = text ? JSON.parse(text) : undefined
      if (json === undefined) continue
      if (predicate(json)) return json as V
    } catch {
    }
  }
  return undefined
}
